import { createReducer } from '@reduxjs/toolkit'
import { IStateAccessGroups } from './TReducer'
import { Actions_AccessGroups } from './Actions'

const initialState: IStateAccessGroups = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerAccessGroups = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_AccessGroups.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_AccessGroups.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_AccessGroups.store.saveAccessGroups, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerAccessGroups
